// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 85) return "static/chunks/85-26326f8c150a6ea8.js";
	// return url for filenames based on template
	return "static/chunks/" + {"164":"reg-login","578":"f857bbdd"}[chunkId] + "." + {"164":"fb36d601045a80ad","578":"5889de2c750adf7f"}[chunkId] + ".js";
};